import angular from 'angular';
import commissionDashboard from './commissionDashboard';
import components from './components';
import './style.scss';

export default angular
  .module('commission.scenes.commissionDashboard', [components])
  .component('commissionDashboard', commissionDashboard).name;
